import d3 from 'd3'
import _ from 'lodash'

export default selfReportImgValue

/** @ngInject */
function selfReportImgValue() {
    return ({
        restrict: 'A',
        scope: {
            ref: '@imgRef',
            values: '=?imgValues',
        },
        link: {
            post(scope, element) {
                const INITIAL_COUNTER = '00000000'

                const watchValues = (key) => () => scope.values[key]()

                const updateDisplayedValueFromObject = (key) => function (value) {
                    if (key === 'illus_CBE_serial_1') {
                        return element.find('#illus_CBE_serial_1').html(`n°00 00 00 000 <tspan font-weight='bold' fill='#2DC7C5'>${value}</tspan> 00`)
                    } else if (key === 'illus_CBE_serial_2') {
                        return element.find('#illus_CBE_serial_2').html(`n°X 000 <tspan font-weight='bold' fill='#2DC7C5'>${value}</tspan>`)
                    } else if (key === 'illus_EMC_serial') {
                        return element.find('#illus_EMC_serial').html(`n°X 000 <tspan font-weight='bold' fill='#2DC7C5'>${value}</tspan>`)
                    } else if (_.isNumber(value)) {
                        const emptyValue = INITIAL_COUNTER.slice(0, INITIAL_COUNTER.length - (`${value}`).length)
                        const displayedValue = `<tspan font-weight='bold' fill='#2DC7C5'>${value}</tspan>`
                        return element.find(`#${key}`).html(emptyValue + displayedValue)
                    }
                    return element.find(`#${key}`).html('00000XXX')
                }

                // Cannot edit <img src='*.svg'>, need to load svg dynamically to edit it
                return d3.xml(scope.ref, 'image/svg+xml', (xml) => {
                    element.html(xml.documentElement)
                    return (() => {
                        _.map(scope.values, (value, key) => {
                            updateDisplayedValueFromObject(key)(value())
                            return scope.$watch(watchValues(key), updateDisplayedValueFromObject(key))
                        })
                    })()
                })
            },
        },
    })
}



// WEBPACK FOOTER //
// ./src/states/selfReport/selfReportImgValue.js